<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="openDialog = true">
                <v-list-tile-content>
                  <v-list-tile-title>IMPORT EXCEL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="exportAllRegion()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-text-field
                name="name"
                label="Region Name"
                type="text"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="statusList"
                label="Choose Status ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.status"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="regionList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.description }}</td>
              <td>
                {{
                  props.item.updatedDateInMilliSeconds
                    | format-ms-date-time
                }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- dialog -->
    <regionExcel :isOpen="openDialog" v-on:change="dialogClose()"></regionExcel>
  </v-container>
</template>

<script>
import { regionService } from "../../services/region-service";
import regionExcel from "../../components/region/regionExcel";
import { commonService } from "../../services/common-service";
export default {
  name: "RegionList",

  components: { regionExcel },
  data: () => ({
    showListLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "General",
        disabled: true,
      },
      {
        text: "Region",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", value: "name", sortable: false },
      { text: "Status", value: "status" },
      { text: "Name", align: "left", value: "name" },
      { text: "Description", value: "description" },
      { text: "Updated  Date", value: "updatedDate" },
      { text: "Updated  By", value: "updatedBy" },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    statusList: [
      { label: "----All----", value: "" },
      { label: "ACTIVE", value: "ACTIVE" },
      { label: "INACTIVE", value: "INACTIVE" },
    ],
    regionList: [],
    totalRows: 0,
    buttonLoading: false,
    openDialog: false,
    queryParams: {
      name: "",
      status: "",
    },
  }),
  watch: {
    pagination: {
      handler() {
        this.getRegionList();
      },
      deep: true,
    },
  },
  created() {
    //for deep linking
    if (this.$route.query.name) {
      this.queryParams.name = this.$route.query.name;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    this.getRegionList();
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "regions", query: this.queryParams });
      this.getRegionList();
    },
    dialogClose() {
      this.openDialog = false;
      this.getRegionList();
    },
    getRegionList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      regionService
        .getRegionList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.regionList = res.data.regionList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    onRegister() {
      this.$router.push("/region/new");
    },
    exportAllRegion() {
      this.buttonLoading = true;
      regionService
        .getRegionExcelExport(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        });
      this.buttonLoading = false;
    },
    onEdit(data) {
      // go to details page
      this.$router.push("/region/" + data.id);
    },
  },
};
</script>